export function maskEmailAddress(email: string): string {
  if (!email || !email.includes('@')) {
    return '';
  }

  const [localPart, domain] = email.split('@');
  if (!domain) {
    return email;
  }

  const visibleCharacters = Math.min(3, localPart.length);
  const visibleLocalPart = localPart.slice(0, visibleCharacters);
  return `${visibleLocalPart}*****@${domain}`;
}
